module.exports = {
    en: {
        news: {
            blog: 'Latest Blog Posts',
        }

    },
    ka: {
        news: {
            blog: 'ბლოგის უახლესი პოსტები',
        }
    },
    ru: {
        news: {
            blog: 'Последние записи в блоге',
        }
    }
}